import {ILookupFilter, IComplexFilter, IBaseFilter, instanceOfIComplexFilter} from './interfaces/Ifilter.lookup';
import {ILookupSort} from './interfaces/Isort.lookup';
import {LookupsService} from "./services/lookups.service";

/**
	****************************************************************
	*  The class represents request for lookup.
	*
	*  Written by: Dana Moshe
	****************************************************************
	*/
export class LookupRequest {

	/**
		* @param lookupName  lookup name.
		* @param nMinRow get lookup rows in range [nMinRow, nMaxRow].
		* @param nMaxRow get lookup rows in range [nMinRow, nMaxRow].
		* @param sort array that contain columns sort by priority.
		* @param filter the filter that run on the current lookup.
		*/
	constructor(public lookupName:string, public nMinRow:number, public nMaxRow:number,
				public sort?:ILookupSort[], public filter?:ILookupFilter, public onlyActive:boolean = true, public tableName:string=null,
				public includeClobAndBlob:boolean = false) {
	}

	public get cacheKey() {
		if ((this.nMinRow !== 0) || (this.nMaxRow !== 2147483647) || (this.sort && this.sort.length) ||
			(this.filter) || (!this.onlyActive)) {
			return null;
		}

		return this.lookupName+(this.tableName?":"+this.tableName:"");
	}

	// toString is used by the LookupService for caching requests
	// todo - consider reusing the Serialization class code
	public toString(){
		return this.lookupName+"-"+this.nMaxRow+"-"+this.nMinRow+"-"+(this.sort?this.sort.forEach(x=>x.field+x.dir):"")+
			"-"+this.stringifyFilter(this.filter);
	}

	public stringifyFilter(f:ILookupFilter){
		let retVal:string=null;
		if (f) {
			if (instanceOfIComplexFilter(f)){
				let complex: IComplexFilter = <IComplexFilter >f;
				retVal = "";
				complex.filters.forEach(x=>retVal = retVal.concat("," + this.stringifyFilter(x)));
				retVal += "." + complex.logic;
			} else {
				let base: IBaseFilter = <IBaseFilter>this.filter;
				retVal = base.field + "," + base.isCaseInvariant + "," + base.operator + "," + base.value;
			}
		}
		return retVal;
	}

	public visitBaseFilters(func:Function ,f:ILookupFilter=this.filter){
		if (f){
			if (instanceOfIComplexFilter(f)){
				let complex: IComplexFilter = <IComplexFilter >f;
				complex.filters.forEach(x=>this.visitBaseFilters(func,x));
			}else{
				func(f);
			}
		}
	}
}
